import React, { useEffect, useState } from 'react';
import Icon from '../AppIcon';
import { fetchTeamMemberHubupQr } from '../../api/teamMembers';

export default function CompanyMemberHubupQrModal({ user, onClose, fetchQr }) {
  const userId = user?._id;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [qrImageUrl, setQrImageUrl] = useState('');

  useEffect(() => {
    if (!fetchQr && !userId) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    const load = fetchQr
      ? fetchQr()
      : fetchTeamMemberHubupQr(userId);
    load
      .then((res) => {
        if (cancelled) return;
        const d = res?.data || {};
        setQrImageUrl(d.qrImageUrl || '');
        if (!d.qrImageUrl) setError('QR indisponible.');
      })
      .catch(() => {
        if (!cancelled) setError('Impossible de charger le QR code.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userId, fetchQr]);

  if (!user) return null;

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 p-4">
      <div className="bg-card rounded-xl shadow-elevation-3 w-full max-w-sm">
        <div className="flex items-center justify-between border-b border-border px-4 py-3">
          <h2 className="text-sm font-semibold text-foreground truncate pr-2">
            QR membre — {user.email}
          </h2>
          <button
            type="button"
            className="p-1.5 rounded hover:bg-muted transition-smooth shrink-0"
            onClick={onClose}
          >
            <Icon name="X" size={16} />
          </button>
        </div>

        <div className="p-4 space-y-4 text-center">
          <p className="text-xs text-muted-foreground text-left">
            Scannez ce QR code depuis l’application HubUP, onglet « Rejoindre une communauté ».
          </p>

          <div className="flex justify-center min-h-[12rem] items-center">
            {loading ? (
              <span className="text-xs text-muted-foreground">Génération…</span>
            ) : qrImageUrl ? (
              <img
                src={qrImageUrl}
                alt="QR membre"
                className="w-48 h-48 object-contain"
                draggable={false}
              />
            ) : null}
          </div>

          {error ? <p className="text-xs text-error">{error}</p> : null}
        </div>
      </div>
    </div>
  );
}
